<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="dark">
            <b-navbar-brand to="/">Jon Scannell</b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item to="/about">About</b-nav-item>
                    <b-nav-item to="/results">Results</b-nav-item>
                    <b-nav-item to="/world-records">World Records</b-nav-item>
                    <b-nav-item to="/contact">Contact</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <div v-for="link in socialLinks" :key="link.id" >
                        <NavbarSocialLink
                            :url="link.url"
                            :imgsrc="link.imgsrc"
                            :tooltip="link.tooltip" />
                    </div>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import { WSSA_PROFILE_URL, YOUTUBE_URL, WCA_PROFILE_URL } from '@/common/constants.js';
import NavbarSocialLink from './NavbarSocialLink.vue';

export default {
    data() {
        return {
            socialLinks: [{
                url: WSSA_PROFILE_URL,
                imgsrc: "wssa_logo.png",
                tooltip: "WSSA"
            }, {
                url: WCA_PROFILE_URL,
                imgsrc: "wca_logo.svg",
                tooltip: "WCA"
            }, {
                url: YOUTUBE_URL,
                imgsrc: "youtube_logo.png",
                tooltip: "YouTube"
            }]
        };
    },
    components: {
        NavbarSocialLink
    }
}
</script>

<style scoped>
    a:focus {
        outline: none;
    }
</style>